// extracted by mini-css-extract-plugin
export default {"expandInfo":"Cadastrar_expandInfo__t5s9J","estiloTabs":"Cadastrar_estiloTabs__VQRnz","btnFormularios":"Cadastrar_btnFormularios__vqEbq"};